import { Modal } from "./";
import { CustomButton } from "./";
import { COLORS } from "../constants";
import { useEffect, useState } from "react"
import phone from "../assets/images/phone.svg"
import { useSelector } from "react-redux"
import {
    EmailShareButton,
    FacebookShareButton,
    FacebookMessengerShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    TwitterIcon,
    FacebookMessengerIcon,
    WhatsappIcon,
} from "react-share";

export function Refer(props) {


    const [quote, setQuote] = useState("Hi there, join me on Tell and Spell application and get 20% discount on first purchase with code REFER20FRIEND");


    return (
        <Modal modalVisible={props.visible} onClose={props.onClose} width="40%">
            <h5 className="color-text-dark-blue">Refer a Friend</h5>
            Refer a friend on social media!


            <div className="mt-3">
                <ul className="list-unstyled">
                    {/* <li className="mt-1">
                        <a className="mr-2" href="sms: &body=Hi%20there, join%20me%20on%20https://app.tellandspell.com%20application%20and%20get%2030%%20discount%20on%20first%20purchase%20with%20discount%20code%20REFER13123FRIEND">
                            <img src={phone} width="40" height="40" />
                        </a>
                       Send a Message
                    </li> */}
                    <li>
                        <FacebookShareButton
                            url={"https://app.tellandspell.com"}
                            quote={quote}
                            hashtag="#tellandspell"
                            className="mr-2"

                        >
                            <FacebookIcon size={40} round={true} />
                        </FacebookShareButton>
                        <span>Refer to Facebook</span>
                    </li>

                    <li className="mt-1">
                        <TwitterShareButton
                            url={"https://app.tellandspell.com"}
                            subject={"Join me on Tell and Spell"}
                            hashtag="#tellandspell"
                            body={quote}
                            className="mr-2"
                            title={"Tell and Spell"}

                        >
                            <TwitterIcon size={40} round={true} />
                        </TwitterShareButton>
                        <span>Refer to Twitter</span>
                    </li>
                    <li className="mt-1">
                        <WhatsappShareButton
                            url={"https://app.tellandspell.com"}
                            subject={quote}
                            hashtag="#tellandspell"
                            quote={quote}
                            title={"Tell and Spell"}
                            className="mr-2"
                        >
                            <WhatsappIcon size={40} round={true} />
                        </WhatsappShareButton>
                        <span>Refer to Whatsapp</span>
                    </li>
                    <li className="mt-1">
                        <EmailShareButton
                            url={"https://app.tellandspell.com"}
                            subject={"Join me on Tell and Spell"}
                            hashtag="#tellandspell"
                            className="mr-2"
                            body={quote}


                        >
                            <EmailIcon size={40} round={true} />
                        </EmailShareButton>
                        <span>Refer via Email</span>
                    </li>
                </ul>
                <div className="text-right">
                    <CustomButton
                        bgColor={COLORS.orange}
                        hover={COLORS.orange_hover}
                        color={COLORS.dark_orange}
                        onClick={props.onClose}
                        style={{ padding: "0 15px", height: 40, fontSize: 15, width: 100 }}
                    >
                        Cancel
                    </CustomButton>
                </div>
            </div >
        </Modal >
    )
}
